import { Box, Theme } from '@mui/material'
import styled from '@emotion/styled'

export const HorizontalMenuSeparator = styled(Box)<{ theme?: Theme }>`
  width: 85%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.text.primary};
  justify-self: center;
`
